import { useContext } from 'react';
import StyledChatListItem from '../../styles/StyledChatListItem';
import Avatar from '../Avatar/Avatar';
import ChatMessageBubble from '../ChatMessageBubble/ChatMessageBubble';
import AppContext from '../../contexts/AppContext';
import AppContextType from '../../types/AppContextType';
import LoadingDots from '../LoadingDots/LoadingDots';

interface ChaListItemProps {
  fromUser: boolean;
  children: React.ReactNode;
  isLoading?: boolean;
  isProcessing?: boolean;
}

const ChatListItem = ({ fromUser, isLoading, isProcessing, children }: ChaListItemProps) => {
  const { configuration } = useContext<AppContextType>(AppContext);

  if (!configuration) return <></>;

  return (
    <StyledChatListItem $fromUser={fromUser}>
      { !fromUser &&
        <div className='avatar-container'>
          <Avatar altText={configuration.company} url={configuration.chat_avatar_url} height='34px' width='34px'/>
          { isProcessing && <LoadingDots />}
        </div>
      }

      {
        fromUser ?
          <ChatMessageBubble fromUser={fromUser}>
            { children }
          </ChatMessageBubble>
          :
          <ChatMessageBubble fromUser={fromUser}>
          { isLoading ? children : <div dangerouslySetInnerHTML={{ __html: typeof children === 'string' ? children : '' }} />}
          </ChatMessageBubble>
      }
    </StyledChatListItem>
  );
};

export default ChatListItem;